
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmtpSettingsDialog extends Serenity.EntityDialog<SmtpSettingsRow, any> {
        protected getFormKey() { return SmtpSettingsForm.formKey; }
        protected getIdProperty() { return SmtpSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return SmtpSettingsRow.localTextPrefix; }
        protected getNameProperty() { return SmtpSettingsRow.nameProperty; }
        protected getService() { return SmtpSettingsService.baseUrl; }
        protected getDeletePermission() { return SmtpSettingsRow.deletePermission; }
        protected getInsertPermission() { return SmtpSettingsRow.insertPermission; }
        protected getUpdatePermission() { return SmtpSettingsRow.updatePermission; }

        protected form = new SmtpSettingsForm(this.idPrefix);

    }
}